export declare namespace InspectionOtherParticipantModalTokenSections {
	interface EditLink {
		color: string;
	}

	interface Header {
		gap: string;
		subtitle: {
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
			color: string;
		};
		title: {
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
			color: string;
		};
	}
}

export type InspectionOtherParticipantModalTokens = {
	editLink: InspectionOtherParticipantModalTokenSections.EditLink;
	header: InspectionOtherParticipantModalTokenSections.Header;
};

export const editLink: InspectionOtherParticipantModalTokenSections.EditLink = {
	color: '{customPlaceholder.color}',
};

export const header: InspectionOtherParticipantModalTokenSections.Header = {
	gap: '12px',
	subtitle: {
		fontSize: '12px',
		lineHeight: '18px',
		fontWeight: '400',
		color: '{text.muted.color}',
	},
	title: {
		fontSize: '24px',
		lineHeight: '32px',
		fontWeight: '500',
		color: '{text.color}',
	},
};

export default {
	editLink,
	header,
} satisfies InspectionOtherParticipantModalTokens;
